import { Link, useNavigate } from "react-router-dom";
import { LogOut, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const Header = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#0A0A0A]/75 border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3">
          <span className="font-display text-lg sm:text-xl tracking-tight text-[#D4AF37] leading-none">
            ART MONEY GROUP
          </span>
        </Link>
        <nav className="flex items-center gap-4 sm:gap-8">
          <Link
            to="/"
            data-testid="nav-catalogue"
            className="text-xs sm:text-sm uppercase tracking-widest text-[#B0B0B0] hover:text-[#D4AF37] transition-colors"
          >
            Catalogue
          </Link>
          {user && (
            <Link
              to="/mes-videos"
              data-testid="nav-my-videos"
              className="text-xs sm:text-sm uppercase tracking-widest text-[#B0B0B0] hover:text-[#D4AF37] transition-colors"
            >
              Mes vidéos
            </Link>
          )}
          {user ? (
            <div className="flex items-center gap-3">
              <span data-testid="user-name" className="hidden md:flex items-center gap-2 text-sm text-[#D4AF37]">
                <User className="w-4 h-4 text-[#D4AF37]" /> {user.name || user.email}
              </span>
              <button
                data-testid="logout-button"
                onClick={() => { logout(); navigate("/"); }}
                className="flex items-center gap-2 text-xs sm:text-sm uppercase tracking-widest text-[#B0B0B0] hover:text-[#D4AF37] transition-colors"
              >
                <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Déconnexion</span>
              </button>
            </div>
          ) : (
            <Link
              to="/connexion"
              data-testid="nav-login"
              className="bg-[#D4AF37] text-[#0A0A0A] font-semibold px-5 py-2.5 text-xs sm:text-sm uppercase tracking-widest hover:bg-[#C9A227] transition-colors"
            >
              Connexion
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};
